import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RedirectTarget.html?raw';


class RedirectTarget extends compose(_WidgetBaseSP) {
    templateString: any = template;

    contentNode: HTMLDivElement;
    headlineNode: HTMLDivElement;
    copyMessageButton: HTMLButtonElement;

    oauth_code: string = null;
    oauth_state: string = null;

     headlineMessage: any = {
         "default": "",
         "error": "",
         "success": ""
     };

    contentMessages: any = {
        "default": "",
        "error": "",
        "success": ""
    };

    processAuthCode(): void {
        this.StandbyStart();

        let jsonData = {
            State: this.oauth_state,
            Code: this.oauth_code
        };

        this.RequestManager.callfunction(
            "OAuth_API_GetAccessTokenFromCode",
            jsonData,
            lang.hitch(this, this._processAuthCodeResponse),
            lang.hitch(this, this._processAuthCodeError),
            true // commit
        );
    }

    protected _processAuthCodeResponse(response: any): void {
        this.StandbyStop();

        this.contentNode.innerHTML = this.contentMessages.success;
        this.headlineNode.innerHTML = this.headlineMessage.success;
        this.UiModder.domClass.add(this.copyMessageButton, "w3-hide");
    }

    protected _processAuthCodeError(error: any): void {
        this.StandbyStop();

        this.contentNode.innerHTML = this.contentMessages.error + "<pre>" + error.Message.replaceAll("\\r\\n", "\r\n") + "</pre>";
        this.headlineNode.innerHTML = this.headlineMessage.error;
        this.UiModder.domClass.remove(this.copyMessageButton, "w3-hide");
    }

    protected _onClick_CopyMessage() {
        this.copyToClipboard(this.contentNode.innerHTML);
        this.copyMessageButton.innerHTML = "<i class=\"fa fa-check w3-text-green\"></i>&nbsp;" + this.translate("OAuth_MessageCopiedToClipboard");
    }

    copyToClipboard: any = function (str) {
        var el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    // International Tel Input Methods----------------------END
    //
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.headlineMessage = {
            "default": "<i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>&nbsp;" + this.translate("OAuth_HeadlineMessage_Default"),
            "error": "<i class=\"fa fa-exclamation-circle w3-text-red\"></i>&nbsp;" + this.translate("OAuth_HeadlineMessage_Error"),
            "success": "<i class=\"fa fa-check w3-text-green\"></i>&nbsp;" + this.translate("OAuth_HeadlineMessage_Success")
        };

        this.contentMessages = {
            "default": this.translate("OAuth_ContentMessage_Default"),
            "error": this.translate("OAuth_ContentMessage_Error"),
            "success": this.translate("OAuth_ContentMessage_Success")
        };


        this.contentNode.innerHTML = this.contentMessages.default;
        this.headlineNode.innerHTML = this.headlineMessage.default;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.oauth_state != null && this.oauth_code != null) {
            this.processAuthCode();
        }
    }
}

export default mdsWidget(RedirectTarget);